export function formatToQuarterAndYear(month: string, year: string): string {
  const quarter = Math.floor((parseInt(month) - 1) / 3) + 1;
  return `Q${quarter} ${year}`;
}
